import {FormInterface} from "./interfaces/FormInterface";

export class Form implements FormInterface {
    id?: string;
    createdAt?: string;
    updatedAt?: string;
    title?: string;
    description?: string;
    type?: string;
    openAt?: string;
    closeAt?: string;
    timeLimit?: number;
    isResubmittingAllowed?: boolean;
    welcomePart?: any;
    viewData?: string;
    submittedAt?: string;
    groupsCount?: number;

    constructor(data: FormInterface) {
        Object.assign(this, data);
    }
}